

























































import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

// Mixins
import OutdoorDisplayMixin from './OutdoorDisplayMixin.vue'

// Component
import BottomSheetLayout from '@/components/common/BottomSheetLayout.vue'
import RoundFilterButton from '../common/buttons/RoundFilterButton.vue'

@Component({
  components: { BottomSheetLayout, RoundFilterButton },
})
export default class OutdoorDisplayMobile extends mixins(OutdoorDisplayMixin) {
  isOpenBottomSheet = false
  mounted() {
    window.addEventListener('load', () => {
      setTimeout(() => {
        window.scrollTo(0, 1)
      }, 100)
    })
  }
}
